class InvertedStep {
  _t: number;
  _x: number;
  _y: number;
  _line: number;
  _point: number;
  _context: any;

  constructor(context, num) {
    this._context = context;
    this._t = num;
  }

  areaStart() {
    this._line = 0;
  }

  areaEnd() {
    this._line = NaN;
  }

  lineStart() {
    this._x = this._y = NaN;
    this._point = 0;
  }

  lineEnd() {
    if (0 < this._t && this._t < 1 && this._point === 2) { this._context.lineTo(this._x, this._y); }
    if (this._line || (this._line !== 0 && this._point === 1)) { this._context.closePath(); }
    if (this._line >= 0) {
      this._t = 1 - this._t;
      this._line = 1 - this._line;
    }
  }

  point(xPos, yPos) {
    xPos = +xPos;
    yPos = +yPos;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(xPos, yPos) : this._context.moveTo(xPos, yPos);
        break;
      case 1:
        this._point = 2;
        /* falls through */
      default:
        if (this._t <= 0) {
          this._context.lineTo(xPos, this._y);
          this._context.lineTo(xPos, yPos);
        } else {
          const yPos1 = this._y * (1 - this._t) + yPos * this._t;
          this._context.lineTo(this._x, yPos1);
          this._context.lineTo(xPos, yPos1);
        }
        break;
    }

    this._x = xPos;
    this._y = yPos;
  }
}

export default function invertedStep(context) {
  return new InvertedStep(context, 0.5);
}
